// extracted by mini-css-extract-plugin
export default {"logoSection":"Logo_logoSection__ynIHS"};